import React, { useContext } from 'react'
import reduce from 'lodash/reduce'
import { navigate } from 'gatsby'
import { useStyletron } from 'baseui'
import { Button } from 'baseui/button'
import { Grid, Cell } from 'baseui/layout-grid'
import { styled } from 'styletron-react'

import StoreContext from '~/context/StoreContext'
import { TABLET, DESKTOP } from '~/utils/styles'

const useQuantity = () => {
  const {
    store: { checkout },
  } = useContext(StoreContext)
  const items = checkout ? checkout.lineItems : []
  const total = reduce(items, (acc, item) => acc + item.quantity, 0)
  return [total !== 0, total]
}

const Navigation = ({ layout }) => {
  const [css, theme] = useStyletron()
  const [hasItems, quantity] = useQuantity()
  const {
    store: { complete },
  } = useContext(StoreContext)

  const [mainItems, setMainItems] = React.useState([
    {
      active: true,
      label: 'Builder',
    },
    { label: `Cart (${quantity})` },
  ])

  return (
    <Nav>
      <Container>
        <Left>
          {layout === 'minimal' ? (
            <div
              onClick={() => navigate('/')}
              kind="minimal"
              className={css({ position: 'relative' })}
            >
              <Icon viewBox="0 0 32 32" layout={layout}>
                <path
                  fill="currentColor"
                  d="M16 6.688q4.438 0 7.563 3.125t3.125 7.5q0 4.438-3.156 7.563t-7.531 3.125-7.531-3.125-3.156-7.563h2.688q0 3.313 2.344 5.656t5.656 2.344 5.656-2.344 2.344-5.656-2.344-5.656-5.656-2.344v5.375l-6.688-6.688 6.688-6.688v5.375z"
                />
              </Icon>
            </div>
          ) : layout !== 'no-back' ? (
            <div
              onClick={() => navigate(-1)}
              kind="minimal"
              className={css({ position: 'relative' })}
            >
              <Icon viewBox="0 0 32 32" layout={layout}>
                <path
                  fill="currentColor"
                  d="M26.688 14.688v2.625h-16.25l7.438 7.5-1.875 1.875-10.688-10.688 10.688-10.688 1.875 1.875-7.438 7.5h16.25z"
                />
              </Icon>
            </div>
          ) : (
            <Spacer />
          )}
        </Left>
        <Middle>
          <img
            onClick={() => navigate('/')}
            className={css({ maxWidth: '100px' })}
            src={require('../images/logo.png')}
          />
        </Middle>
        <Right>
          <div
            kind="minimal"
            onClick={() => navigate('/cart')}
            className={css({ position: 'relative' })}
          >
            <Icon viewBox="0 0 32 32" layout={layout}>
              <path
                fill="#000"
                d="M22.688 24q1.063 0 1.844 0.813t0.781 1.875-0.781 1.844-1.844 0.781-1.875-0.781-0.813-1.844 0.813-1.875 1.875-0.813zM1.313 2.688h4.375l1.25 2.625h19.75q0.563 0 0.938 0.406t0.375 0.969q0 0.063-0.188 0.625l-4.75 8.625q-0.75 1.375-2.313 1.375h-9.938l-1.188 2.188-0.063 0.188q0 0.313 0.313 0.313h15.438v2.688h-16q-1.063 0-1.844-0.813t-0.781-1.875q0-0.625 0.313-1.25l1.813-3.313-4.813-10.125h-2.688v-2.625zM9.313 24q1.063 0 1.875 0.813t0.813 1.875-0.813 1.844-1.875 0.781-1.844-0.781-0.781-1.844 0.781-1.875 1.844-0.813z"
              />
            </Icon>
            {hasItems && <Quantity>{quantity}</Quantity>}
          </div>
        </Right>
      </Container>
    </Nav>
  )
}

export default Navigation

const Icon = styled('svg', {
  width: '32px',
  height: '32px',
  cursor: 'pointer',
})

const Quantity = styled('span', {
  background: 'var(--red-500)',
  color: 'white',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  fontSize: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  right: '-8px',
  top: '-8px',
})

const Nav = styled('div', {
  width: '100%',
  height: '80px',
  display: 'flex',

  [TABLET]: {
    padding: '0 18px',
  },
})

const Container = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '15px',
  margin: '0 auto',

  [TABLET]: {
    padding: '15px 45.5px',
    maxWidth: '100%',
  },

  [DESKTOP]: {
    padding: '15px 45.5px',
    maxWidth: '100%',
  },
})

const Left = styled('div', {
  color: 'black',
})

const Right = styled('div', {
  color: 'red',
})

const Spacer = styled('div', {
  width: '32px',
})

const Middle = styled('div', {
  cursor: 'pointer',
})
